import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Box, Button, Typography } from "@material-ui/core";
import { pathName } from "pages/routes";

export const PageNotFound = () => {
    const { t } = useTranslation();
    const { push } = useHistory();
    return (
        <Box p={4} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
            <Typography variant="h1">404</Typography>
            <Typography variant="h5">PAGE NOT FOUND</Typography>
            <Typography variant="body1">The page you are looking for does not exist</Typography>
            <Box p={4}>
                <Button color="primary" onClick={() => push(pathName.MAIN)}>
                    {t("buttons.label.backToHome")}
                </Button>
            </Box>
        </Box>
    );
};
